import React from 'react';
import { FiCheck } from "react-icons/fi";


const PricingFive = () => {
    return (
        <div className="row row--15 d-flex">

            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-5 h-100">
                    <div className="pricing-table-inner h-100">
                        <div className="pricing-header">
                            <h4 className="title">Basic Plan</h4>
                            <div className="pricing">
                                <span className="subtitle text-left ml-2">FROM</span>
                                <div className="price-wrapper">
                                    <span className="currency"><sub></sub>KES. </span>
                                    <span className="price">25, 000</span>
                                </div>
                            </div>
                        </div>
                        <div className="pricing-body mx-2">
                            <ul className="list-style--1">
                                <li><FiCheck /> FREE 1 year hosting (Basic Hosting)</li>
                                <li><FiCheck /> FREE 1 year domain</li>
                                <li><FiCheck /> Custom Design</li>
                                <li><FiCheck /> Social Media Integration</li>
                                <li><FiCheck /> Optimized Graphics</li>
                                <li><FiCheck /> Upto 8 pages</li>
                            </ul>
                        </div>
                        <div className="pricing-footer position-absolute bottom">
                            <a className="btn-default" href="#">Request a Quote</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}

            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-5 h-100">
                    <div className="pricing-table-inner h-100">
                        <div className="pricing-header">
                            <h4 className="title">Standard Plan</h4>
                            <div className="pricing">
                                <span className="subtitle text-left ml-2">FROM</span>
                                <div className="price-wrapper">
                                    <span className="currency">KES. </span>
                                    <span className="price">40, 500</span>
                                </div>
                            </div>
                        </div>
                        <div className="pricing-body mx-2">
                            <ul className="list-style--1">
                                <li><FiCheck /> Basic Plan Features</li>
                                <li><FiCheck /> Content Management System</li>
                                <li><FiCheck /> Dynamic Content</li>
                                <li><FiCheck /> Upto 5 Modules Integration</li>
                                <li><FiCheck /> Administration Panel</li>
                                <li><FiCheck /> FREE Training</li>
                                <li><FiCheck /> 1 Month free support</li>
                            </ul>
                        </div>
                        <div className="pricing-footer position-absolute bottom">
                            <a className="btn-default" href="#">Request a Quote</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}

            {/* Start PRicing Table Area  */}
            <div className="col-lg-4 col-md-6 col-12">
                <div className="rn-pricing style-5 h-100">
                    <div className="pricing-table-inner h-100">
                        <div className="pricing-header">
                            <h4 className="title">Corporate Plan</h4>
                            <div className="pricing">
                                <span className="subtitle text-left ml-2">FROM</span>
                                <div className="price-wrapper">
                                    <span className="currency">KES. </span>
                                    <span className="price">75, 500</span>
                                </div>
                            </div>
                        </div>
                        <div className="pricing-body mx-2">
                            <ul className="list-style--1">
                                <li><FiCheck /> FREE 1 year domain and hosting (Gold Hosting)</li>
                                <li><FiCheck /> Features in other Packages</li>
                                <li><FiCheck /> Modules Integration</li>
                                <li><FiCheck /> Payments Integration</li>
                                <li><FiCheck /> Custom designs and dynamic content</li>
                                <li><FiCheck /> FREE training & 3 months support</li>
                            </ul>
                        </div>
                        <div className="pricing-footer position-absolute bottom">
                            <a className="btn-default" href="#">Request a Quote</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* End PRicing Table Area  */}

        </div>
    )
}
export default PricingFive;
